import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useState } from "react";
import { useEffect } from "react";

const PayPal = (props) => {
  const [totalPrice, setTotalPrice] = useState();

  useEffect(() => {
    setTotalPrice(props.totalPrice);
  }, [props.totalPrice]);

  return (
    <div>
      <PayPalScriptProvider
        options={{
          "client-id": "test",
        }}
      >
        <PayPalButtons
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    currency_code: "USD",
                    value: Math.round(totalPrice * 100) / 100,
                  },
                },
              ],
            });
          }}
          onApprove={(data, actions) => {
            return actions.order.capture().then(function(details) {
              props.handleCheckout();
            });
          }}
        />
      </PayPalScriptProvider>
    </div>
  );
};

PayPal.propTypes = {};

export default PayPal;
